import { get } from 'lodash';

export function getCallURLById(id) {
  return `${process.env.CALL_URL}/${id}`;
}

export function getOrderURLById(id) {
  return `${process.env.ORDER_URL}/${id}`;
}

export function getTicketFromHistory(history) {
  const pathname = get(history, 'location.pathname');
  const regex = /\/tickets\/(\d+)(?:\/(\d+))?/;
  const matches = pathname.match(regex);

  return matches && matches[1];
}

export function getChainFromHistory(history) {
  const pathname = get(history, 'location.pathname');
  const regex = /\/tickets\/(\d+)(?:\/(\d+))?/;
  const matches = pathname.match(regex);

  return matches && matches[2];
}

export function getTaskFromHistory(history) {
  const pathname = get(history, 'location.pathname');
  const regex = /\/tasks\/(\d+)(?:\/(\d+))?/;
  const matches = pathname.match(regex);

  return matches && matches[1];
}

export function getQueryParamFromHistory(history, param) {
  const search = get(history, 'location.search');
  const parsedData = new URLSearchParams(search);
  return parsedData.get(param);
}
